/* global ajax_object */

import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

$(function () {
  $('.js-acf-products-with-filter-block').each(function () {
    initProductsFilterWithIsotope($(this));
  });
});

function initProductsFilterWithIsotope($block) {
  const $tabsWrap = $block.find('.fwp-filter-tabs--categories');
  const $list = $block.find('.products-grid__list');
  const locationTerm = String($block.data('location') || '');

  // Init Isotope once per block
  const iso = new Isotope($list[0], {
    itemSelector: '.products-grid__list-item',
    layoutMode: 'fitRows',
    percentPosition: true,
    transitionDuration: '0.3s',
  });

  // Layout after images load
  imagesLoaded($list[0]).on('progress', () => iso.layout());

  let inflight = null;
  let lastKey = '';

  $tabsWrap.on('click', '.fwp-filter-tab', function (e) {
    e.preventDefault();

    const $btn = $(this);
    const category = String($btn.data('value') || 'all');
    const key = `${category}|${locationTerm}`;

    if ($btn.hasClass('active') || key === lastKey) return;

    $tabsWrap
      .find('.fwp-filter-tab')
      .removeClass('active')
      .attr('aria-selected', 'false');
    $btn.addClass('active').attr('aria-selected', 'true');

    if (inflight && inflight.readyState !== 4) {
      inflight.abort();
    }

    inflight = $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      dataType: 'json',
      timeout: 15000,
      data: {
        action: 'filter_products',
        nonce: ajax_object.nonce,
        category,
        location: locationTerm,
        paged: 1,
      },
      beforeSend() {
        $list.addClass('is-loading');
      },
      success(res) {
        if (!res || !res.success) {
          console.error('AJAX response error:', res);
          return;
        }

        const $newItems = $(res.data.html).filter('.products-grid__list-item');

        // Always remove any old grid items managed by Isotope
        const oldItems = $list.children('.products-grid__list-item').get();
        if (oldItems.length) {
          iso.remove(oldItems);
        }

        if ($newItems.length) {
          // If previously showed empty-state, remove it
          $list.find('.products-grid__empty').remove();

          // Append new items + tell Isotope
          $list.append($newItems);
          iso.appended($newItems.get());

          // Relayout after images load
          imagesLoaded($list[0], () => iso.layout());
        } else {
          // No products → show server-provided empty-state markup
          $list.html(res.data.html); // contains .products-grid__empty
          // Optional: layout to settle container height
          iso.layout();
        }

        lastKey = key;
      },
      error(xhr, status, error) {
        if (status !== 'abort') {
          console.error('AJAX request failed:', status, error);
        }
      },
      complete() {
        $list.removeClass('is-loading');
        inflight = null;
      },
    });
  });
}
